import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SearchRides = () => {
    const [searchData, setSearchData] = useState({ date: '', time: '', from: '', to: '' });
    const [rides, setRides] = useState([]);
    const [hasSearched, setHasSearched] = useState(false);
    
    const navigate = useNavigate();
    const location = useLocation();

    // --- NEW: IRIS SAML Token Catcher ---
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const urlToken = queryParams.get('token');

        if (urlToken) {
            // 1. Save the secure token to the browser
            localStorage.setItem('token', urlToken);
            
            // 2. Clean up the URL so the massive token string disappears
            // Change '/home' to whatever your actual route path is if it differs
            navigate('/home', { replace: true }); 
        }
    }, [location, navigate]);
    // ------------------------------------

    const handleChange = (e) => {
        setSearchData({ ...searchData, [e.target.name]: e.target.value });
    };

    const handleSearch = async (e) => {
        e.preventDefault();
        setHasSearched(true);
        if (!searchData.date) return alert("Please select a date");

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/api/rides/search?date=${searchData.date}&time=${searchData.time}&from=${searchData.from}&to=${searchData.to}`,
                { headers: { 'Authorization': localStorage.getItem('token') } }
            );
            const result = await response.json();
            if (result.success && result.rides.length > 0) {
                setRides(result.rides);
            } else {
                setRides([]);
            }
        } catch (error) {
            console.error(error);
            alert("Error fetching rides");
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    const handleAddRide = () => {
        navigate('/Add_ride', { state: searchData });
    };

    return (
        <div className="ui-page">
            <div className="ui-container">
                <div className="ui-header">
                    <div>
                        <h1 className="ui-title">Search for a ride</h1>
                        <p className="ui-subtitle">Find a match by date, time, and destination.</p>
                    </div>
                    <div className="ui-actions">
                        <button className="ui-btn ui-btn-secondary" onClick={() => navigate('/profile')}>
                            Profile
                        </button>
                        <button className="ui-btn ui-btn-danger" onClick={handleLogout}>
                            Logout
                        </button>
                    </div>
                </div>

                <div className="ui-grid ui-grid-2" style={{ alignItems: 'start' }}>
                    <div className="ui-card">
                        <div className="ui-card-body">
                            <div className="ui-card-title">About Share My Ride</div>
                            <p className="ui-subtitle" style={{ marginTop: 0 }}>
                                A community-driven platform to share rides, save money, and reduce carbon footprint within NITK.
                            </p>
                            <div className="ui-divider" />
                            <ul className="ui-list">
                                <li>Easy ride sharing</li>
                                <li>Save travel costs</li>
                                <li>Connect with the NITK community</li>
                            </ul>
                        </div>
                    </div>

                    <div className="ui-stack">
                        <div className="ui-card">
                            <div className="ui-card-body">
                                <div className="ui-card-title">Search</div>
                                <form onSubmit={handleSearch} className="ui-stack" style={{ gap: '0.9rem' }}>
                                    <div className="ui-field">
                                        <label className="ui-label" htmlFor="date">Date</label>
                                        <input id="date" className="ui-input" type="date" name="date" value={searchData.date} onChange={handleChange} required />
                                    </div>

                                    <div className="ui-field">
                                        <label className="ui-label" htmlFor="time">Time (optional)</label>
                                        <input id="time" className="ui-input" type="time" name="time" value={searchData.time} onChange={handleChange} />
                                    </div>

                                    <div className="ui-field">
                                        <label className="ui-label" htmlFor="from">From</label>
                                        <select id="from" className="ui-select" name="from" value={searchData.from} onChange={handleChange} required>
                                            <option value="">Select</option>
                                            <option value="NITK">NITK</option>
                                            <option value="Mangalore Airport">Mangalore Airport</option>
                                            <option value="Mangalore Junction Railway Station">Mangalore Junction Railway Station</option>
                                            <option value="Manglore Central Railway Station">Manglore Central Railway Station</option>
                                            <option value="Surathkal bus stand">Surathkal bus stand</option>
                                            <option value="Surathkal Railway Station">Surathkal Railway Station</option>
                                        </select>
                                    </div>

                                    <div className="ui-field">
                                        <label className="ui-label" htmlFor="to">To</label>
                                        <select id="to" className="ui-select" name="to" value={searchData.to} onChange={handleChange} required>
                                            <option value="">Select</option>
                                            <option value="NITK">NITK</option>
                                            <option value="Mangalore Airport">Mangalore Airport</option>
                                            <option value="Mangalore Junction Railway Station">Mangalore Junction Railway Station</option>
                                            <option value="Manglore Central Railway Station">Manglore Central Railway Station</option>
                                            <option value="Surathkal Bus stand">Surathkal bus stand</option>
                                            <option value="Surathkal Railway Station">Surathkal Railway Station</option>
                                        </select>
                                    </div>

                                    <button className="ui-btn ui-btn-primary ui-btn-block" type="submit">
                                        Search rides
                                    </button>
                                </form>
                            </div>
                        </div>

                        {hasSearched && (
                            <div className="ui-card">
                                <div className="ui-card-body">
                                    <div className="ui-card-title" style={{ marginBottom: '0.75rem' }}>
                                        Results {rides.length > 0 ? <span className="ui-badge" style={{ marginLeft: '0.5rem' }}>{rides.length}</span> : null}
                                    </div>

                                    {rides.length > 0 ? (
                                        <div className="ui-stack" style={{ gap: '0.9rem' }}>
                                            {rides.map((ride, index) => (
                                                <div key={index} className="ui-card" style={{ boxShadow: '0 1px 2px rgba(15, 23, 42, 0.05)' }}>
                                                    <div className="ui-card-body">
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '0.75rem', flexWrap: 'wrap', alignItems: 'center' }}>
                                                            <div style={{ fontWeight: 900, letterSpacing: '-0.02em' }}>
                                                                {ride.from} → {ride.to}
                                                            </div>
                                                        </div>

                                                        <div className="ui-divider" style={{ margin: '0.9rem 0' }} />

                                                        <div className="ui-kv">
                                                            <div><strong>Date</strong><div>{ride.date}</div></div>
                                                            <div><strong>Time</strong><div>{ride.time}</div></div>
                                                            <div><strong>Name</strong><div>{ride.userName}</div></div>
                                                            <div><strong>Gender</strong><div>{ride.gender}</div></div>
                                                            <div><strong>Phone</strong><div>{ride.phoneNumber || '—'}</div></div>
                                                            <div><strong>Email</strong><div>{ride.email || '—'}</div></div>
                                                        </div>

                                                        <div className="ui-divider" style={{ margin: '0.9rem 0' }} />

                                                        <div className="ui-actions" style={{ justifyContent: 'space-between', width: '100%' }}>
                                                            <div className="ui-subtitle" style={{ margin: 0, fontSize: '0.9rem' }}>
                                                                Listed by {ride.userName}
                                                            </div>
                                                            {ride.telegram ? (
                                                                <a
                                                                    className="ui-btn ui-btn-secondary"
                                                                    href={`https://t.me/${ride.telegram.replace(/^@/, '')}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    Message on Telegram
                                                                </a>
                                                            ) : (
                                                                <span className="ui-badge">No Telegram</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div style={{ textAlign: 'center', padding: '1rem 0' }}>
                                            <p className="ui-subtitle" style={{ margin: 0 }}>No rides found.</p>
                                        </div>
                                    )}

                                    <div className="ui-divider" />
                                    <button className="ui-btn ui-btn-success ui-btn-block" onClick={handleAddRide}>
                                        Not suitable? Add your own ride
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchRides;